import {
    CREATE_REFUND_SUCCESS,
    CREATE_REFUND_ERROR,
    GET_REFUND_SUCCESS,
    GET_ALL_REFUNDS_SUCCESS,
    GET_PAYMENT_REFUNDS_SUCCESS,
    REFUND_LOADING,
    REFUND_ERROR,
    CLEAR_REFUND
} from '../actions/types';

const initialState = {
    refund: null,
    refunds: [],
    paymentRefunds: [],
    loading: false,
    error: null,
    pagination: {
        count: 0,
        total: 0,
        skip: 0
    },
    filters: null
};

export default function refund(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case REFUND_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CREATE_REFUND_SUCCESS:
            return {
                ...state,
                refund: payload.data,
                loading: false,
                error: null
            };

        case GET_REFUND_SUCCESS:
            return {
                ...state,
                refund: payload.data,
                loading: false,
                error: null
            };

        case GET_ALL_REFUNDS_SUCCESS:
            return {
                ...state,
                refunds: payload.data || [],
                pagination: {
                    count: payload.count || 0,
                    total: payload.total || 0,
                    skip: payload.skip || 0
                },
                loading: false,
                error: null
            };

        case GET_PAYMENT_REFUNDS_SUCCESS:
            return {
                ...state,
                paymentRefunds: payload.data || [],
                pagination: {
                    count: payload.count || 0,
                    total: payload.total || 0,
                    skip: payload.skip || 0
                },
                filters: payload.filters || null,
                loading: false,
                error: null
            };

        case CREATE_REFUND_ERROR:
        case REFUND_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case CLEAR_REFUND:
            return {
                ...state,
                refund: null,
                error: null
            };

        default:
            return state;
    }
}

